import { Language } from "../languages/labels/language.labels";

export function statusQuoteList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'pending', display: lang.labels.pending },
    { code: 'approved', display: lang.labels.approved },
    { code: 'rejected', display: lang.labels.rejected },
    { code: 'completed', display: lang.labels.completed }
  ]
}

export function statusOrderList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'pending', display: lang.labels.pending },
    { code: 'approved', display: lang.labels.approved },
    { code: 'canceled', display: lang.labels.canceled },
    { code: 'completed', display: lang.labels.completed }
  ]
}

export function statusInvoiceList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'draft', display: lang.labels.draft },
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'sent', display: lang.labels.sent },
    { code: 'reminder', display: lang.labels.reminder },
    { code: 'in-dispute', display: lang.labels.inDispute },
    { code: 'completed', display: lang.labels.completed },
    { code: 'charged-off', display: lang.labels.chargedOff }
  ]
}

export function statusProviderQuoteList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'received', display: lang.labels.received },
    { code: 'accepted', display: lang.labels.accepted },
    { code: 'declined', display: lang.labels.declined },
    { code: 'expired', display: lang.labels.expired },
  ]
}

export function statusProviderOrderList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'draft', display: lang.labels.draft },
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'approved', display: lang.labels.approved },
    { code: 'canceled', display: lang.labels.canceled },
    { code: 'completed', display: lang.labels.completed }
  ]
}

export function statusProviderInvoiceList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'draft', display: lang.labels.draft },
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'approved', display: lang.labels.approved },
    { code: 'completed', display: lang.labels.completed }
  ]
}

export function statusExpense(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'draft', display: lang.labels.draft },
    { code: 'in-progress', display: lang.labels.inProgress },
    { code: 'completed', display: lang.labels.completed }
  ]
}

export function statusExpenseReport(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'draft', display: lang.labels.draft },
    { code: 'submitted', display: lang.labels.submitted },
    { code: 'validated', display: lang.labels.validated },
    { code: 'rejected', display: lang.labels.rejected }
  ]
}

export function statusDocumentList(lang: Language): {code: string, display: string}[] {
  let statusRecord = [...statusQuoteList(lang), ...statusOrderList(lang), ...statusInvoiceList(lang), ...statusProviderQuoteList(lang), ...statusProviderOrderList(lang), ...statusProviderInvoiceList(lang), ...statusExpense(lang), ...statusExpenseReport(lang)]
  return Array.from((new Map(statusRecord.map((item) => [item.code, item]))).values())
}

export function normalizeStatus(status: string): string {
  if (!status) return ''
  let normalized = status.trim().toLowerCase().replace(/\s+/g, '-')
  if (normalized === 'cancelled') normalized = 'canceled'
  return normalized
}

export function statusDocumentValue(lang: Language, code: string): string {
  let statusRecord = statusDocumentList(lang).find((item) => (item.code === normalizeStatus(code)))
  return statusRecord ? statusRecord.display : lang.labels.undefined
}
